/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdistatus.ts                     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edistatus";

export class AutogenModelEdistatus<RowType extends ModelRow> extends Endpoint<RowType, RowEdistatusFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdistatus extends ModelRow<RowEdistatusFields> {
	constructor(values?: Partial<RowEdistatusFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdistatusFields {
	actual_arrival: Date;
	actual_departure: Date;
	agent_payee_id: string;
	alt_partner_id: string;
	appointment_date: Date;
	batch: number;
	bill_plant: string;
	blnum: string;
	carrier_id: string;
	carrier_name: string;
	carrier_trailer: string;
	cc_pro_nbr: string;
	collection_method: string;
	commodity: string;
	commodity_id: string;
	company_id: string;
	cons_address: string;
	cons_address_inbound: string;
	cons_city_id: string;
	cons_city_id_inbound: string;
	cons_city_name: string;
	cons_city_name_inbound: string;
	cons_contact_name_inbound: string;
	cons_latitude_inbound: string;
	cons_loc_id: string;
	cons_loc_name: string;
	cons_loc_name_inbound: string;
	cons_longitude_inbound: string;
	cons_phone_inbound: string;
	cons_state: string;
	cons_state_inbound: string;
	"cons_stop.actual_arrival": Date;
	"cons_stop.actual_departure": Date;
	"cons_stop.address": string;
	"cons_stop.address2": string;
	"cons_stop.appointment_status_id": string;
	"cons_stop.appt_contact_name": string;
	"cons_stop.appt_required": string;
	"cons_stop.cases": number;
	"cons_stop.city_id": number;
	"cons_stop.city_name": string;
	"cons_stop.company_id": string;
	"cons_stop.confirmed": string;
	"cons_stop.contact_email": string;
	"cons_stop.contact_name": string;
	"cons_stop.dist_from_prev": number;
	"cons_stop.dist_from_prev_um": string;
	"cons_stop.driver_load_unload": string;
	"cons_stop.edi_code": string;
	"cons_stop.edi_loc_code": string;
	"cons_stop.eta": Date;
	"cons_stop.eta_distance": number;
	"cons_stop.eta_late": string;
	"cons_stop.eta_oor": string;
	"cons_stop.google_place_id": string;
	"cons_stop.grouped_id": number;
	"cons_stop.hub": number;
	"cons_stop.ic_stop_id": string;
	"cons_stop.id": string;
	"cons_stop.inbound_status": string;
	"cons_stop.late_eta_colorcode": string;
	"cons_stop.late_route_status": string;
	"cons_stop.latitude": number;
	"cons_stop.location_id": string;
	"cons_stop.location_name": string;
	"cons_stop.longitude": number;
	"cons_stop.manifest_fgp_uid": number;
	"cons_stop.manifest_reg_uid": number;
	"cons_stop.move_dist_from_preassign": number;
	"cons_stop.move_dist_from_preassign_um": string;
	"cons_stop.move_dist_from_previous": number;
	"cons_stop.move_dist_from_previous_um": string;
	"cons_stop.movement_id": string;
	"cons_stop.movement_sequence": number;
	"cons_stop.operational_status": string;
	"cons_stop.order_id": string;
	"cons_stop.order_sequence": number;
	"cons_stop.orig_sched_early": Date;
	"cons_stop.orig_sched_late": Date;
	"cons_stop.pallets_dropped": number;
	"cons_stop.pallets_picked_up": number;
	"cons_stop.payment_code_reviewed": string;
	"cons_stop.phone": string;
	"cons_stop.planned_arrival_time": Date;
	"cons_stop.ponum": string;
	"cons_stop.prior_uncleared_stops": string;
	"cons_stop.projected_arrival": Date;
	"cons_stop.pu_override_arrive_early": Date;
	"cons_stop.pu_override_arrive_late": Date;
	"cons_stop.rate_dist_from_previous": number;
	"cons_stop.rate_dist_from_previous_um": string;
	"cons_stop.refno": string;
	"cons_stop.requested_service": string;
	"cons_stop.sched_arrive_early": Date;
	"cons_stop.sched_arrive_late": Date;
	"cons_stop.seal": string;
	"cons_stop.service_date": Date;
	"cons_stop.showas_address": string;
	"cons_stop.showas_address2": string;
	"cons_stop.showas_city_id": number;
	"cons_stop.showas_city_name": string;
	"cons_stop.showas_location_id": string;
	"cons_stop.showas_location_name": string;
	"cons_stop.showas_state": string;
	"cons_stop.showas_zip_code": string;
	"cons_stop.signed_for_name": string;
	"cons_stop.state": string;
	"cons_stop.status": string;
	"cons_stop.stop_type": string;
	"cons_stop.trimble_place_id": string;
	"cons_stop.txl_uid": number;
	"cons_stop.volume": number;
	"cons_stop.volume_um": string;
	"cons_stop.weight": number;
	"cons_stop.weight_um": string;
	"cons_stop.zip_code": string;
	"cons_stop.zone_id": string;
	cons_stop_id: string;
	cons_zip_code: string;
	cons_zip_code_inbound: string;
	"consignee_location.address1": string;
	"consignee_location.address2": string;
	"consignee_location.appt_required": string;
	"consignee_location.assigned_to": string;
	"consignee_location.bseg": string;
	"consignee_location.category": string;
	"consignee_location.cbsa_port_id": string;
	"consignee_location.chassis_owner": string;
	"consignee_location.chassis_pool": string;
	"consignee_location.city_id": number;
	"consignee_location.city_name": string;
	"consignee_location.class_rqmt": string;
	"consignee_location.comments": string;
	"consignee_location.company_id": string;
	"consignee_location.container_pool": string;
	"consignee_location.container_vendor": string;
	"consignee_location.cust_id": string;
	"consignee_location.customer_id": string;
	"consignee_location.days_between_calls": number;
	"consignee_location.ded_rqmt_type": string;
	"consignee_location.ded_type": string;
	"consignee_location.def_commodity_desc": string;
	"consignee_location.def_commodity_id": string;
	"consignee_location.delivery_date_option": string;
	"consignee_location.directions": string;
	"consignee_location.disable_loc_rating": string;
	"consignee_location.dl_gen_cost": number;
	"consignee_location.dl_gen_repower": number;
	"consignee_location.dl_haz_cost": number;
	"consignee_location.dl_haz_repower": number;
	"consignee_location.dl_hvl_cost": number;
	"consignee_location.dl_hvl_repower": number;
	"consignee_location.dl_load_time": number;
	"consignee_location.dl_svc_cost": number;
	"consignee_location.dl_svc_repower": number;
	"consignee_location.dl_unload_time": number;
	"consignee_location.driver_load_id": string;
	"consignee_location.driver_unload_id": string;
	"consignee_location.ds_capacity_cost": number;
	"consignee_location.ds_model_flag": string;
	"consignee_location.extra_handling_time": number;
	"consignee_location.filer_code": string;
	"consignee_location.foreign_port": string;
	"consignee_location.friday_close": Date;
	"consignee_location.friday_open": Date;
	"consignee_location.fuel_price_region": string;
	"consignee_location.google_place_fm_address": string;
	"consignee_location.google_place_id": string;
	"consignee_location.google_place_type": string;
	"consignee_location.id": string;
	"consignee_location.include_xref_trailers": string;
	"consignee_location.insur_amt_rqrd": number;
	"consignee_location.insur_amt_rqrd_c": string;
	"consignee_location.insur_amt_rqrd_d": Date;
	"consignee_location.insur_amt_rqrd_n": number;
	"consignee_location.insur_amt_rqrd_r": number;
	"consignee_location.is_active": string;
	"consignee_location.is_consignee": string;
	"consignee_location.is_customer": string;
	"consignee_location.is_customs_broker": string;
	"consignee_location.is_dist_center": string;
	"consignee_location.is_dl_gen": string;
	"consignee_location.is_dl_haz": string;
	"consignee_location.is_dl_hvl": string;
	"consignee_location.is_dl_svc": string;
	"consignee_location.is_drop_yard": string;
	"consignee_location.is_geocoded": string;
	"consignee_location.is_outside_terminal": string;
	"consignee_location.is_prospect": string;
	"consignee_location.is_remote_terminal": string;
	"consignee_location.is_shipper": string;
	"consignee_location.is_steamship": string;
	"consignee_location.is_terminal": string;
	"consignee_location.is_trailer_pool": string;
	"consignee_location.is_trailer_wash": string;
	"consignee_location.is_truckstop": string;
	"consignee_location.last_used_date": Date;
	"consignee_location.latitude": number;
	"consignee_location.layover": string;
	"consignee_location.load_unload_count": number;
	"consignee_location.load_unload_excl": string;
	"consignee_location.load_unload_param": string;
	"consignee_location.loading_instructs": string;
	"consignee_location.loading_time": number;
	"consignee_location.longitude": number;
	"consignee_location.ltl_optimize_time_per_spot": number;
	"consignee_location.ltl_seg_alloc_code": string;
	"consignee_location.manual_exchange": string;
	"consignee_location.max_drvr_complaint": number;
	"consignee_location.max_pallet_balance": number;
	"consignee_location.max_payment_code_amt": number;
	"consignee_location.max_payment_code_amt_c": string;
	"consignee_location.max_payment_code_amt_d": Date;
	"consignee_location.max_payment_code_amt_n": number;
	"consignee_location.max_payment_code_amt_r": number;
	"consignee_location.model_flag": string;
	"consignee_location.monday_close": Date;
	"consignee_location.monday_open": Date;
	"consignee_location.name": string;
	"consignee_location.need_clean_trailer": string;
	"consignee_location.next_call_date": Date;
	"consignee_location.no_fuel_radius_inbound": string;
	"consignee_location.no_fuel_radius_outbound": number;
	"consignee_location.no_stop_miles": number;
	"consignee_location.on_duty_not_driving_mins": number;
	"consignee_location.pallet_balance": number;
	"consignee_location.pallets_required": string;
	"consignee_location.payment_api_excluded": string;
	"consignee_location.pickup_date_option": string;
	"consignee_location.plc_uid": number;
	"consignee_location.pnn_city_id": number;
	"consignee_location.pnn_city_name": string;
	"consignee_location.pnn_state": string;
	"consignee_location.pnn_zip_code": string;
	"consignee_location.port_id": string;
	"consignee_location.prev_code": string;
	"consignee_location.primary_agency": string;
	"consignee_location.radius": number;
	"consignee_location.regulated": string;
	"consignee_location.reload_rqmt": string;
	"consignee_location.reserve_mins": number;
	"consignee_location.salesperson": string;
	"consignee_location.saturday_close": Date;
	"consignee_location.saturday_open": Date;
	"consignee_location.shuttle_capacity": string;
	"consignee_location.state": string;
	"consignee_location.sunday_close": Date;
	"consignee_location.sunday_open": Date;
	"consignee_location.swap_cost": number;
	"consignee_location.team_rqmt": string;
	"consignee_location.thursday_close": Date;
	"consignee_location.thursday_open": Date;
	"consignee_location.trailer_pool_min": number;
	"consignee_location.trailer_pool_radius": number;
	"consignee_location.trailer_pool_size": number;
	"consignee_location.trailer_wash_vend": string;
	"consignee_location.trimble_place_id": string;
	"consignee_location.trip_starter": string;
	"consignee_location.tuesday_close": Date;
	"consignee_location.tuesday_open": Date;
	"consignee_location.tw_seg_code": string;
	"consignee_location.unload_instructs": string;
	"consignee_location.unloading_time": number;
	"consignee_location.website_url": string;
	"consignee_location.wednesday_close": Date;
	"consignee_location.wednesday_open": Date;
	"consignee_location.zip_code": string;
	consignee_plant: string;
	copied_from_id: string;
	create_date: Date;
	create_user_id: string;
	curr_address: string;
	curr_cases: number;
	curr_city_id: number;
	curr_city_name: string;
	curr_city_name_inbound: string;
	curr_contact_name: string;
	curr_latitude: number;
	curr_loc_id: string;
	curr_loc_name: string;
	curr_longitude: number;
	curr_phone: string;
	curr_plant: string;
	curr_state: string;
	curr_state_inbound: string;
	curr_stop_id: string;
	curr_stop_type: string;
	curr_volume: number;
	curr_volume_um: string;
	curr_weight: number;
	curr_weight_um: string;
	curr_zip_code: string;
	curr_zip_code_inbound: string;
	"current_stop.actual_arrival": Date;
	"current_stop.actual_departure": Date;
	"current_stop.address": string;
	"current_stop.address2": string;
	"current_stop.appointment_status_id": string;
	"current_stop.appt_contact_name": string;
	"current_stop.appt_required": string;
	"current_stop.cases": number;
	"current_stop.city_id": number;
	"current_stop.city_name": string;
	"current_stop.company_id": string;
	"current_stop.confirmed": string;
	"current_stop.contact_email": string;
	"current_stop.contact_name": string;
	"current_stop.dist_from_prev": number;
	"current_stop.dist_from_prev_um": string;
	"current_stop.driver_load_unload": string;
	"current_stop.edi_code": string;
	"current_stop.edi_loc_code": string;
	"current_stop.eta": Date;
	"current_stop.eta_distance": number;
	"current_stop.eta_late": string;
	"current_stop.eta_oor": string;
	"current_stop.google_place_id": string;
	"current_stop.grouped_id": number;
	"current_stop.hub": number;
	"current_stop.ic_stop_id": string;
	"current_stop.id": string;
	"current_stop.inbound_status": string;
	"current_stop.late_eta_colorcode": string;
	"current_stop.late_route_status": string;
	"current_stop.latitude": number;
	"current_stop.location_id": string;
	"current_stop.location_name": string;
	"current_stop.longitude": number;
	"current_stop.manifest_fgp_uid": number;
	"current_stop.manifest_reg_uid": number;
	"current_stop.move_dist_from_preassign": number;
	"current_stop.move_dist_from_preassign_um": string;
	"current_stop.move_dist_from_previous": number;
	"current_stop.move_dist_from_previous_um": string;
	"current_stop.movement_id": string;
	"current_stop.movement_sequence": number;
	"current_stop.operational_status": string;
	"current_stop.order_id": string;
	"current_stop.order_sequence": number;
	"current_stop.orig_sched_early": Date;
	"current_stop.orig_sched_late": Date;
	"current_stop.pallets_dropped": number;
	"current_stop.pallets_picked_up": number;
	"current_stop.payment_code_reviewed": string;
	"current_stop.phone": string;
	"current_stop.planned_arrival_time": Date;
	"current_stop.ponum": string;
	"current_stop.prior_uncleared_stops": string;
	"current_stop.projected_arrival": Date;
	"current_stop.pu_override_arrive_early": Date;
	"current_stop.pu_override_arrive_late": Date;
	"current_stop.rate_dist_from_previous": number;
	"current_stop.rate_dist_from_previous_um": string;
	"current_stop.refno": string;
	"current_stop.requested_service": string;
	"current_stop.sched_arrive_early": Date;
	"current_stop.sched_arrive_late": Date;
	"current_stop.seal": string;
	"current_stop.service_date": Date;
	"current_stop.showas_address": string;
	"current_stop.showas_address2": string;
	"current_stop.showas_city_id": number;
	"current_stop.showas_city_name": string;
	"current_stop.showas_location_id": string;
	"current_stop.showas_location_name": string;
	"current_stop.showas_state": string;
	"current_stop.showas_zip_code": string;
	"current_stop.signed_for_name": string;
	"current_stop.state": string;
	"current_stop.status": string;
	"current_stop.stop_type": string;
	"current_stop.trimble_place_id": string;
	"current_stop.txl_uid": number;
	"current_stop.volume": number;
	"current_stop.volume_um": string;
	"current_stop.weight": number;
	"current_stop.weight_um": string;
	"current_stop.zip_code": string;
	"current_stop.zone_id": string;
	customer_id: string;
	delay_code: string;
	delay_desc: string;
	delivery_signature: string;
	direction: string;
	"edi_batch_history.batch": number;
	"edi_batch_history.company_id": string;
	"edi_batch_history.create_date": Date;
	"edi_batch_history.id": string;
	"edi_batch_history.trans_count": number;
	"edi_batch_history.transaction_id": string;
	"edi_batch_history.transaction_type": string;
	edi_commodity_id: string;
	edi_equip_type_id: string;
	"edi_log.as2_msg_id": string;
	"edi_log.batch": number;
	"edi_log.company_id": string;
	"edi_log.create_date": Date;
	"edi_log.descr": string;
	"edi_log.direction": string;
	"edi_log.directory_local": string;
	"edi_log.edi_comm_id": number;
	"edi_log.file_local_dir": string;
	"edi_log.filename": string;
	"edi_log.func_batch": number;
	"edi_log.func_receiver_id": string;
	"edi_log.func_sender_id": string;
	"edi_log.func_version": string;
	"edi_log.id": string;
	"edi_log.interchange_id": number;
	"edi_log.intercompany": string;
	"edi_log.internal_filename": string;
	"edi_log.message_id": string;
	"edi_log.message_timestamp": number;
	"edi_log.orig_profile_id": string;
	"edi_log.orig_trans_type": string;
	"edi_log.partner_company": string;
	"edi_log.receiver_id": string;
	"edi_log.sender_id": string;
	"edi_log.set_control_no": number;
	"edi_log.status": string;
	"edi_log.template_id": number;
	"edi_log.total_func_grps": number;
	"edi_log.transaction_type": string;
	"edi_log.version": string;
	"edi_log.was_successful": string;
	"edi_template.ack_required": string;
	"edi_template.app_receiver_code": string;
	"edi_template.app_receiver_id": string;
	"edi_template.app_sender_code": string;
	"edi_template.app_sender_id": string;
	"edi_template.authen_info": string;
	"edi_template.authen_info_qual": string;
	"edi_template.company_id": string;
	"edi_template.ctl_version": string;
	"edi_template.ctl_version_qual": string;
	"edi_template.descr": string;
	"edi_template.direction": string;
	"edi_template.ele_separator": number;
	"edi_template.end_of_line_1": number;
	"edi_template.end_of_line_2": number;
	"edi_template.filepath": string;
	"edi_template.format_type": string;
	"edi_template.functional_id": string;
	"edi_template.id": number;
	"edi_template.industry": string;
	"edi_template.is_multi_partner": string;
	"edi_template.name": string;
	"edi_template.parse_batch_number": string;
	"edi_template.parse_create_date": string;
	"edi_template.parse_create_datef": string;
	"edi_template.parse_fg_segment": string;
	"edi_template.parse_tran_ctrl_no": string;
	"edi_template.parse_tran_segment": string;
	"edi_template.receiver_id": string;
	"edi_template.receiver_qual": string;
	"edi_template.secur_info": string;
	"edi_template.secur_info_qual": string;
	"edi_template.sender_id": string;
	"edi_template.sender_qual": string;
	"edi_template.spec_footer_text": string;
	"edi_template.spec_header_text": string;
	"edi_template.spec_title": string;
	"edi_template.standard": string;
	"edi_template.subele_separator": number;
	"edi_template.tag_format_text": string;
	"edi_template.test_indicator": string;
	"edi_template.transaction_set": string;
	"edi_template.transaction_type": string;
	"edi_template.translation_method": string;
	"edi_template.update_date": Date;
	"edi_template.version": string;
	edi_template_format_type: string;
	"edistatus_profile.ack_xmit_method": string;
	"edistatus_profile.agent_payee_id": string;
	"edistatus_profile.allow_update": string;
	"edistatus_profile.alt_partner_id": string;
	"edistatus_profile.audit_cutoff_days": number;
	"edistatus_profile.audit_interval": number;
	"edistatus_profile.batch_method": string;
	"edistatus_profile.carrier_id": string;
	"edistatus_profile.company_id": string;
	"edistatus_profile.consolidates_stops": string;
	"edistatus_profile.create_method": string;
	"edistatus_profile.create_svrfail": string;
	"edistatus_profile.days_to_retain": number;
	"edistatus_profile.delay_req": string;
	"edistatus_profile.dest_stop_no": string;
	"edistatus_profile.direction": string;
	"edistatus_profile.edi_comm_id": number;
	"edistatus_profile.enf_batch_cont": string;
	"edistatus_profile.enf_batch_cont_997": string;
	"edistatus_profile.fa_threshold": number;
	"edistatus_profile.filename": string;
	"edistatus_profile.func_ack_filename": string;
	"edistatus_profile.func_ack_st02_frmt": string;
	"edistatus_profile.func_ack_tid": number;
	"edistatus_profile.func_altpartner_id": string;
	"edistatus_profile.func_comm_id": number;
	"edistatus_profile.func_next_batch": number;
	"edistatus_profile.func_partner_id": string;
	"edistatus_profile.func_use_m_batch": string;
	"edistatus_profile.func_version": string;
	"edistatus_profile.hold_for_preverr": string;
	"edistatus_profile.hold_type": string;
	"edistatus_profile.id": string;
	"edistatus_profile.ignore_map_errors": string;
	"edistatus_profile.img_def_loc_dir": string;
	"edistatus_profile.img_dir_local": string;
	"edistatus_profile.img_document_types": string;
	"edistatus_profile.img_filetype": string;
	"edistatus_profile.img_required": string;
	"edistatus_profile.individual_batch": string;
	"edistatus_profile.intercompany": string;
	"edistatus_profile.next_batch": number;
	"edistatus_profile.notes": string;
	"edistatus_profile.orig_stop_no": string;
	"edistatus_profile.partner_id": string;
	"edistatus_profile.partner_name": string;
	"edistatus_profile.process_priority": number;
	"edistatus_profile.remove_file": string;
	"edistatus_profile.remove_func_ack": string;
	"edistatus_profile.send_func_ack": string;
	"edistatus_profile.send_to_company": string;
	"edistatus_profile.skip_manual_orders": string;
	"edistatus_profile.special_processing": string;
	"edistatus_profile.st02_format": string;
	"edistatus_profile.status_on_delivery": string;
	"edistatus_profile.status_on_pickup": string;
	"edistatus_profile.template_id": number;
	"edistatus_profile.transaction_set": string;
	"edistatus_profile.transmit_method": string;
	"edistatus_profile.update_stop": string;
	"edistatus_profile.use_master_batch": string;
	"edistatus_profile.use_show_as": string;
	"edistatus_profile.version": string;
	edistatus_profile_partner_name: string;
	edistatus_profile_send_func_ack: string;
	equipment_type_id: string;
	error: number;
	error_count: string;
	error_descr: string;
	error_description: string;
	eta: Date;
	eta_next_stop: Date;
	event_type: string;
	except1_code: string;
	except1_qual: string;
	except1_quant: number;
	except2_code: string;
	except2_qual: string;
	except2_quant: number;
	frt_grp_pro_nbr: string;
	func_ack_batch: number;
	func_ack_id: string;
	func_ack_rec: string;
	func_ack_rec_date: Date;
	func_ack_status: string;
	gs06_group_cntlno: string;
	has_error_out: string;
	hazmat_code_id: string;
	hold_delay_code: string;
	hold_trailer_id: string;
	id: string;
	inquiry_request: string;
	intercompany: string;
	is_resend: string;
	isa13_intr_cntlno: string;
	manifest_id: string;
	"movement.authorized": string;
	"movement.average_broker_rating": number;
	"movement.booking_no": string;
	"movement.br_details_link": string;
	"movement.br_status_link": string;
	"movement.br_track_interval": number;
	"movement.br_track_status": string;
	"movement.br_track_status_desc": string;
	"movement.br_track_vehicle_id": string;
	"movement.br_tracking_id": string;
	"movement.br_vendor": string;
	"movement.broker_avail_tract": string;
	"movement.brokerage": string;
	"movement.brokerage_status": string;
	"movement.carrier_contact": string;
	"movement.carrier_email": string;
	"movement.carrier_empty_from_city_id": number;
	"movement.carrier_fuel_pay_rate_id": number;
	"movement.carrier_lane_rate_id": string;
	"movement.carrier_override_carrier": string;
	"movement.carrier_override_user": string;
	"movement.carrier_phone": string;
	"movement.carrier_rate_id": number;
	"movement.carrier_tractor": string;
	"movement.carrier_trailer": string;
	"movement.carrier_trailer_type": string;
	"movement.chassis": string;
	"movement.checkcall_sched_id": string;
	"movement.company_id": string;
	"movement.container": string;
	"movement.container_returned": string;
	"movement.container_status": string;
	"movement.controlling_carrier_code": string;
	"movement.dedicated_order_id": string;
	"movement.dest_stop_id": string;
	"movement.digital_booking": string;
	"movement.dispatcher_user_id": string;
	"movement.eform_rate_confirmation": string;
	"movement.empty2next_order": string;
	"movement.equipment_group_id": string;
	"movement.est_tolls": number;
	"movement.est_tolls_c": string;
	"movement.est_tolls_d": Date;
	"movement.est_tolls_n": number;
	"movement.est_tolls_r": number;
	"movement.exclude_movement": string;
	"movement.fleet_manager": string;
	"movement.freight_matching_override": string;
	"movement.fuel_distance": number;
	"movement.fuel_distance_um": string;
	"movement.fuel_tax_exempt": string;
	"movement.hubtran_approved_inv_date": Date;
	"movement.hubtran_ok2pay_date": Date;
	"movement.ic_company_to": string;
	"movement.ic_order_to": string;
	"movement.id": string;
	"movement.integrated_carrier_search": string;
	"movement.invoice_recv_date": Date;
	"movement.is_container": string;
	"movement.is_dray": string;
	"movement.is_intercompany": string;
	"movement.is_local_mile": string;
	"movement.linked_id": number;
	"movement.linked_sequence": number;
	"movement.load_booking_eligible": string;
	"movement.load_booking_source": string;
	"movement.loaded": string;
	"movement.locked_user_id": string;
	"movement.ltl": string;
	"movement.ltl_staging_wrs_uid": number;
	"movement.macropoint_status": string;
	"movement.manifest_empty_distance": number;
	"movement.manifest_estimated_arrival": Date;
	"movement.manifest_estimated_depart": Date;
	"movement.manifest_id": string;
	"movement.manifest_loaded_distance": number;
	"movement.manifest_reg_uid": number;
	"movement.manifest_spots_capacity": number;
	"movement.manifest_spots_consumed": number;
	"movement.manifest_weight_capacity": number;
	"movement.manifest_weight_consumed": number;
	"movement.max_buy": number;
	"movement.max_buy_c": string;
	"movement.max_buy_d": Date;
	"movement.max_buy_n": number;
	"movement.max_buy_r": number;
	"movement.max_pay_method": string;
	"movement.max_pay_units": number;
	"movement.missed_call_sent": string;
	"movement.move_distance": number;
	"movement.move_distance_um": string;
	"movement.movement_type": string;
	"movement.must_respond_by": Date;
	"movement.next_sched_call": Date;
	"movement.operational_status": string;
	"movement.operations_user": string;
	"movement.origin_stop_id": string;
	"movement.override_crny_type": string;
	"movement.override_driver2_id": number;
	"movement.override_driver2_nm": string;
	"movement.override_driver_id": number;
	"movement.override_driver_nm": string;
	"movement.override_drvr2_cell": string;
	"movement.override_drvr2_email": string;
	"movement.override_drvr_cell": string;
	"movement.override_drvr_email": string;
	"movement.override_max_pay": number;
	"movement.override_max_pay_c": string;
	"movement.override_max_pay_d": Date;
	"movement.override_max_pay_n": number;
	"movement.override_max_pay_r": number;
	"movement.override_pay_amt": number;
	"movement.override_pay_amt_c": string;
	"movement.override_pay_amt_d": Date;
	"movement.override_pay_amt_n": number;
	"movement.override_pay_amt_r": number;
	"movement.override_pay_rate": number;
	"movement.override_paye_rate": number;
	"movement.override_payee_id": string;
	"movement.override_targetpay": number;
	"movement.override_targetpay_c": string;
	"movement.override_targetpay_d": Date;
	"movement.override_targetpay_n": number;
	"movement.override_targetpay_r": number;
	"movement.override_type": string;
	"movement.override_unit_desc": string;
	"movement.override_units": number;
	"movement.pay_distance": number;
	"movement.pay_distance_um": string;
	"movement.pending_carrier_name": string;
	"movement.pending_carrier_nbr": string;
	"movement.pending_carrier_type": string;
	"movement.pending_payee_id": string;
	"movement.placard_required": string;
	"movement.preassign_sequence": number;
	"movement.priority": string;
	"movement.pro_nbr": string;
	"movement.rate_alert_basis": string;
	"movement.rate_alert_date": Date;
	"movement.rate_alert_days": number;
	"movement.rate_alert_hours": number;
	"movement.rate_alert_minutes": number;
	"movement.rate_confirm_template": number;
	"movement.rate_confirmation_sent_date": Date;
	"movement.rate_confirmation_status": string;
	"movement.rate_expiration_basis": string;
	"movement.rate_expiration_date": Date;
	"movement.rate_expiration_days": number;
	"movement.rate_expiration_hours": number;
	"movement.rate_expiration_minutes": number;
	"movement.rdy_pickup_date": Date;
	"movement.recurring_movement_id": string;
	"movement.reminder_sent": string;
	"movement.require_tracking": string;
	"movement.required_vendor": string;
	"movement.reserved": string;
	"movement.return_date": Date;
	"movement.seg_alloc_code": string;
	"movement.shipper_email": string;
	"movement.shipper_notify_frequency": string;
	"movement.shpmt_ident_type": string;
	"movement.shpmt_ident_value": string;
	"movement.ss_location_id": string;
	"movement.status": string;
	"movement.target_extra_stop_pay": number;
	"movement.target_extra_stop_pay_c": string;
	"movement.target_extra_stop_pay_d": Date;
	"movement.target_extra_stop_pay_n": number;
	"movement.target_extra_stop_pay_r": number;
	"movement.target_fuel_surcharge_pay": string;
	"movement.target_pay": number;
	"movement.target_pay_c": string;
	"movement.target_pay_d": Date;
	"movement.target_pay_method": string;
	"movement.target_pay_n": number;
	"movement.target_pay_r": number;
	"movement.target_pay_units": number;
	"movement.target_rate_data": string;
	"movement.target_rate_id": number;
	"movement.time_to_send_msg": Date;
	"movement.track_start_date": Date;
	"movement.tracking_duration_ext": number;
	"movement.tracking_notify_email": string;
	"movement.tracking_request_status": string;
	"movement.trailer_rent_pct": number;
	"movement.trip_lease": string;
	"movement.trip_mgt_recalc_datetime": Date;
	"movement.trip_mgt_tracking_id": string;
	"movement.triumphpay_exclude": string;
	"movement.trp_uid": number;
	"movement.ts_borrowing_company": string;
	"movement.ts_commodity": string;
	"movement.ts_movement_id": string;
	"movement.unlock_time": Date;
	"movement.waterfall_flood_time": Date;
	"movement.waterfall_in_progress": string;
	"movement.xfer2settle_date": Date;
	"movement.xferred2fueltax": string;
	"movement.xferred2fueltaxdt": Date;
	"movement.xmit_accepted": string;
	"movement.xmitted2driver": Date;
	"movement.zmit_trip": string;
	movement_id: string;
	movement_sequence: number;
	movement_xfer2settle_date: string;
	next_plant: string;
	next_stop_id: string;
	"order_consignee.actual_arrival": Date;
	"order_consignee.actual_departure": Date;
	"order_consignee.address": string;
	"order_consignee.address2": string;
	"order_consignee.appointment_status_id": string;
	"order_consignee.appt_contact_name": string;
	"order_consignee.appt_required": string;
	"order_consignee.cases": number;
	"order_consignee.city_id": number;
	"order_consignee.city_name": string;
	"order_consignee.company_id": string;
	"order_consignee.confirmed": string;
	"order_consignee.contact_email": string;
	"order_consignee.contact_name": string;
	"order_consignee.dist_from_prev": number;
	"order_consignee.dist_from_prev_um": string;
	"order_consignee.driver_load_unload": string;
	"order_consignee.edi_code": string;
	"order_consignee.edi_loc_code": string;
	"order_consignee.eta": Date;
	"order_consignee.eta_distance": number;
	"order_consignee.eta_late": string;
	"order_consignee.eta_oor": string;
	"order_consignee.google_place_id": string;
	"order_consignee.grouped_id": number;
	"order_consignee.hub": number;
	"order_consignee.ic_stop_id": string;
	"order_consignee.id": string;
	"order_consignee.inbound_status": string;
	"order_consignee.late_eta_colorcode": string;
	"order_consignee.late_route_status": string;
	"order_consignee.latitude": number;
	"order_consignee.location_id": string;
	"order_consignee.location_name": string;
	"order_consignee.longitude": number;
	"order_consignee.manifest_fgp_uid": number;
	"order_consignee.manifest_reg_uid": number;
	"order_consignee.move_dist_from_preassign": number;
	"order_consignee.move_dist_from_preassign_um": string;
	"order_consignee.move_dist_from_previous": number;
	"order_consignee.move_dist_from_previous_um": string;
	"order_consignee.movement_id": string;
	"order_consignee.movement_sequence": number;
	"order_consignee.operational_status": string;
	"order_consignee.order_id": string;
	"order_consignee.order_sequence": number;
	"order_consignee.orig_sched_early": Date;
	"order_consignee.orig_sched_late": Date;
	"order_consignee.pallets_dropped": number;
	"order_consignee.pallets_picked_up": number;
	"order_consignee.payment_code_reviewed": string;
	"order_consignee.phone": string;
	"order_consignee.planned_arrival_time": Date;
	"order_consignee.ponum": string;
	"order_consignee.prior_uncleared_stops": string;
	"order_consignee.projected_arrival": Date;
	"order_consignee.pu_override_arrive_early": Date;
	"order_consignee.pu_override_arrive_late": Date;
	"order_consignee.rate_dist_from_previous": number;
	"order_consignee.rate_dist_from_previous_um": string;
	"order_consignee.refno": string;
	"order_consignee.requested_service": string;
	"order_consignee.sched_arrive_early": Date;
	"order_consignee.sched_arrive_late": Date;
	"order_consignee.seal": string;
	"order_consignee.service_date": Date;
	"order_consignee.showas_address": string;
	"order_consignee.showas_address2": string;
	"order_consignee.showas_city_id": number;
	"order_consignee.showas_city_name": string;
	"order_consignee.showas_location_id": string;
	"order_consignee.showas_location_name": string;
	"order_consignee.showas_state": string;
	"order_consignee.showas_zip_code": string;
	"order_consignee.signed_for_name": string;
	"order_consignee.state": string;
	"order_consignee.status": string;
	"order_consignee.stop_type": string;
	"order_consignee.trimble_place_id": string;
	"order_consignee.txl_uid": number;
	"order_consignee.volume": number;
	"order_consignee.volume_um": string;
	"order_consignee.weight": number;
	"order_consignee.weight_um": string;
	"order_consignee.zip_code": string;
	"order_consignee.zone_id": string;
	order_cube: number;
	order_id: string;
	order_pieces: number;
	"order_shipper.actual_arrival": Date;
	"order_shipper.actual_departure": Date;
	"order_shipper.address": string;
	"order_shipper.address2": string;
	"order_shipper.appointment_status_id": string;
	"order_shipper.appt_contact_name": string;
	"order_shipper.appt_required": string;
	"order_shipper.cases": number;
	"order_shipper.city_id": number;
	"order_shipper.city_name": string;
	"order_shipper.company_id": string;
	"order_shipper.confirmed": string;
	"order_shipper.contact_email": string;
	"order_shipper.contact_name": string;
	"order_shipper.dist_from_prev": number;
	"order_shipper.dist_from_prev_um": string;
	"order_shipper.driver_load_unload": string;
	"order_shipper.edi_code": string;
	"order_shipper.edi_loc_code": string;
	"order_shipper.eta": Date;
	"order_shipper.eta_distance": number;
	"order_shipper.eta_late": string;
	"order_shipper.eta_oor": string;
	"order_shipper.google_place_id": string;
	"order_shipper.grouped_id": number;
	"order_shipper.hub": number;
	"order_shipper.ic_stop_id": string;
	"order_shipper.id": string;
	"order_shipper.inbound_status": string;
	"order_shipper.late_eta_colorcode": string;
	"order_shipper.late_route_status": string;
	"order_shipper.latitude": number;
	"order_shipper.location_id": string;
	"order_shipper.location_name": string;
	"order_shipper.longitude": number;
	"order_shipper.manifest_fgp_uid": number;
	"order_shipper.manifest_reg_uid": number;
	"order_shipper.move_dist_from_preassign": number;
	"order_shipper.move_dist_from_preassign_um": string;
	"order_shipper.move_dist_from_previous": number;
	"order_shipper.move_dist_from_previous_um": string;
	"order_shipper.movement_id": string;
	"order_shipper.movement_sequence": number;
	"order_shipper.operational_status": string;
	"order_shipper.order_id": string;
	"order_shipper.order_sequence": number;
	"order_shipper.orig_sched_early": Date;
	"order_shipper.orig_sched_late": Date;
	"order_shipper.pallets_dropped": number;
	"order_shipper.pallets_picked_up": number;
	"order_shipper.payment_code_reviewed": string;
	"order_shipper.phone": string;
	"order_shipper.planned_arrival_time": Date;
	"order_shipper.ponum": string;
	"order_shipper.prior_uncleared_stops": string;
	"order_shipper.projected_arrival": Date;
	"order_shipper.pu_override_arrive_early": Date;
	"order_shipper.pu_override_arrive_late": Date;
	"order_shipper.rate_dist_from_previous": number;
	"order_shipper.rate_dist_from_previous_um": string;
	"order_shipper.refno": string;
	"order_shipper.requested_service": string;
	"order_shipper.sched_arrive_early": Date;
	"order_shipper.sched_arrive_late": Date;
	"order_shipper.seal": string;
	"order_shipper.service_date": Date;
	"order_shipper.showas_address": string;
	"order_shipper.showas_address2": string;
	"order_shipper.showas_city_id": number;
	"order_shipper.showas_city_name": string;
	"order_shipper.showas_location_id": string;
	"order_shipper.showas_location_name": string;
	"order_shipper.showas_state": string;
	"order_shipper.showas_zip_code": string;
	"order_shipper.signed_for_name": string;
	"order_shipper.state": string;
	"order_shipper.status": string;
	"order_shipper.stop_type": string;
	"order_shipper.trimble_place_id": string;
	"order_shipper.txl_uid": number;
	"order_shipper.volume": number;
	"order_shipper.volume_um": string;
	"order_shipper.weight": number;
	"order_shipper.weight_um": string;
	"order_shipper.zip_code": string;
	"order_shipper.zone_id": string;
	order_weight: number;
	order_weight_um: string;
	ordered_date: Date;
	"orders.actual_reefer_profile": string;
	"orders.agency_id": string;
	"orders.agent_payee_id": string;
	"orders.all_vendors_enabled": string;
	"orders.allow_relay": string;
	"orders.autorate_status": string;
	"orders.bill_date": Date;
	"orders.bill_distance": number;
	"orders.bill_distance_um": string;
	"orders.billing_empty_distance": number;
	"orders.billing_empty_distance_um": string;
	"orders.billing_loaded_distance": number;
	"orders.billing_loaded_distance_um": string;
	"orders.billing_user_id": string;
	"orders.blnum": string;
	"orders.bol_note": string;
	"orders.bol_received": string;
	"orders.bol_recv_date": Date;
	"orders.booking_no": string;
	"orders.booking_number": string;
	"orders.brk_qual_profile": string;
	"orders.broker_location_id": string;
	"orders.brokerage_workflow_id": string;
	"orders.cbp_crossing_date": Date;
	"orders.cbp_crossing_location_id": string;
	"orders.cbp_crossing_reason": string;
	"orders.cbsa_crossing_date": Date;
	"orders.cbsa_crossing_location_id": string;
	"orders.cbsa_crossing_reason": string;
	"orders.cc_fuel_revenue": number;
	"orders.cc_fuel_revenue_c": string;
	"orders.cc_fuel_revenue_d": Date;
	"orders.cc_fuel_revenue_n": number;
	"orders.cc_fuel_revenue_r": number;
	"orders.cc_net_revenue": number;
	"orders.cc_net_revenue_c": string;
	"orders.cc_net_revenue_d": Date;
	"orders.cc_net_revenue_n": number;
	"orders.cc_net_revenue_r": number;
	"orders.cc_pro_nbr": string;
	"orders.cobroker_location_id": string;
	"orders.collection_method": string;
	"orders.com_setpnt_temp": number;
	"orders.com_setpnt_temp_dt": Date;
	"orders.com_setpnt_temp_um": string;
	"orders.commitment_id": string;
	"orders.commodity": string;
	"orders.commodity_id": string;
	"orders.company_id": string;
	"orders.consignee_refno": string;
	"orders.consignee_stop_id": string;
	"orders.container": string;
	"orders.container_planned": string;
	"orders.container_type_id": string;
	"orders.controlling_carrier_code": string;
	"orders.copy_from_company": string;
	"orders.copy_from_order_id": string;
	"orders.copy_to_company": string;
	"orders.copy_to_order_id": string;
	"orders.ctrl_party_id": string;
	"orders.cube": number;
	"orders.curr_movement_id": string;
	"orders.cust_order_no": string;
	"orders.customer_id": string;
	"orders.declared_val": number;
	"orders.def_move_type": string;
	"orders.default_match_id": string;
	"orders.dim_height": string;
	"orders.dim_length": string;
	"orders.dim_surcharge": number;
	"orders.dim_surcharge_c": string;
	"orders.dim_surcharge_d": Date;
	"orders.dim_surcharge_n": number;
	"orders.dim_surcharge_r": number;
	"orders.dim_width": string;
	"orders.dispatch_opt": string;
	"orders.dl_team_reqd": string;
	"orders.dray_del_date": Date;
	"orders.dray_del_pay": number;
	"orders.dray_del_pay_c": string;
	"orders.dray_del_pay_d": Date;
	"orders.dray_del_pay_n": number;
	"orders.dray_del_pay_r": number;
	"orders.dray_del_payee": string;
	"orders.dray_del_xfer_dt": Date;
	"orders.dray_pu_date": Date;
	"orders.dray_pu_pay": number;
	"orders.dray_pu_pay_c": string;
	"orders.dray_pu_pay_d": Date;
	"orders.dray_pu_pay_n": number;
	"orders.dray_pu_pay_r": number;
	"orders.dray_pu_payee": string;
	"orders.dray_pu_xfer_dt": Date;
	"orders.eir1_no": string;
	"orders.eir2_no": string;
	"orders.entered_user_id": string;
	"orders.equipment_type_id": string;
	"orders.equipment_type_options": string;
	"orders.est_tolls": number;
	"orders.est_tolls_c": string;
	"orders.est_tolls_d": Date;
	"orders.est_tolls_n": number;
	"orders.est_tolls_r": number;
	"orders.excise_disable_update": string;
	"orders.excise_taxable": string;
	"orders.excisetax_total": number;
	"orders.excisetax_total_c": string;
	"orders.excisetax_total_d": Date;
	"orders.excisetax_total_n": number;
	"orders.excisetax_total_r": number;
	"orders.external_invoiceno": string;
	"orders.extra_deliveries": number;
	"orders.extra_pickups": number;
	"orders.floor_loaded_freight": string;
	"orders.force_assign": string;
	"orders.forwd_location_id": string;
	"orders.free_days": number;
	"orders.freight_charge": number;
	"orders.freight_charge_c": string;
	"orders.freight_charge_d": Date;
	"orders.freight_charge_n": number;
	"orders.freight_charge_r": number;
	"orders.hazmat": string;
	"orders.hazmat_code": string;
	"orders.high_value": string;
	"orders.hold_reason": string;
	"orders.ic_company_from": string;
	"orders.ic_movement_from": string;
	"orders.ic_order_from": string;
	"orders.id": string;
	"orders.image_is_present": string;
	"orders.import_export": string;
	"orders.include_split_point": string;
	"orders.intelliset": string;
	"orders.invoice_recv_date": Date;
	"orders.is_auto_tonu": string;
	"orders.is_autorate_dist": string;
	"orders.is_container": string;
	"orders.is_dedicated": string;
	"orders.is_intercompany": string;
	"orders.is_local_mile": string;
	"orders.is_requested": string;
	"orders.is_tonu": string;
	"orders.jag_carrier_id": string;
	"orders.jag_cost_rate_id": number;
	"orders.ldport_location_id": string;
	"orders.linear_feet_avail": number;
	"orders.load_date": Date;
	"orders.loadboard": string;
	"orders.loadboard_post_movement_id": string;
	"orders.lock_miles": string;
	"orders.ltl": string;
	"orders.markup_flat": number;
	"orders.markup_flat_c": string;
	"orders.markup_flat_d": Date;
	"orders.markup_flat_n": number;
	"orders.markup_flat_r": number;
	"orders.markup_percent": number;
	"orders.master_order_id": string;
	"orders.master_sequence": number;
	"orders.next_rebill": string;
	"orders.nte_lp_num": string;
	"orders.nte_lp_qual": string;
	"orders.on_hold": string;
	"orders.operational_status": string;
	"orders.operations_user": string;
	"orders.optimize": string;
	"orders.optiset": string;
	"orders.order_mode": string;
	"orders.order_type_id": string;
	"orders.order_value": number;
	"orders.order_value_c": string;
	"orders.order_value_d": Date;
	"orders.order_value_n": number;
	"orders.order_value_r": number;
	"orders.ordered_by": string;
	"orders.ordered_by_id": string;
	"orders.ordered_date": Date;
	"orders.ordered_method": string;
	"orders.orig_dest_rate_id": string;
	"orders.otherchargetotal": number;
	"orders.otherchargetotal_c": string;
	"orders.otherchargetotal_d": Date;
	"orders.otherchargetotal_n": number;
	"orders.otherchargetotal_r": number;
	"orders.override_arrive_early": Date;
	"orders.override_arrive_late": Date;
	"orders.override_posting_city_id": number;
	"orders.pallets_how_many": number;
	"orders.pallets_required": string;
	"orders.pay_gross": number;
	"orders.pay_gross_c": string;
	"orders.pay_gross_d": Date;
	"orders.pay_gross_n": number;
	"orders.pay_gross_r": number;
	"orders.pick_up_no": string;
	"orders.pieces": number;
	"orders.placard_required": string;
	"orders.planning_comment": string;
	"orders.pnn_callback": string;
	"orders.pnn_comment": string;
	"orders.pnn_comment2": string;
	"orders.pnn_loadboard_user_id": string;
	"orders.pnn_post_type": string;
	"orders.pnn_rate": number;
	"orders.pnn_rate_type": string;
	"orders.pnn_trailer_length": number;
	"orders.pnn_trailer_width": number;
	"orders.ponum": string;
	"orders.port": string;
	"orders.port_of_discharge": string;
	"orders.preferred_vendors": string;
	"orders.preload_trailer_id": string;
	"orders.preloaded": string;
	"orders.rate": number;
	"orders.rate_currency_type": string;
	"orders.rate_id": number;
	"orders.rate_min_weight": number;
	"orders.rate_min_weight_um": string;
	"orders.rate_source": string;
	"orders.rate_type": string;
	"orders.rate_unit_desc": string;
	"orders.rate_units": number;
	"orders.ready_to_bill": string;
	"orders.recurring_order_id": string;
	"orders.reply_transmitted": string;
	"orders.requesting_company": string;
	"orders.return_temp": number;
	"orders.return_temp_dt": Date;
	"orders.return_temp_um": string;
	"orders.return_temp_var": number;
	"orders.return_temp_var_um": string;
	"orders.revenue_code_id": string;
	"orders.revenue_share_method": string;
	"orders.round_trip": string;
	"orders.sail_date": Date;
	"orders.seal_number": string;
	"orders.seg_alloc_code": string;
	"orders.setpoint_temp": number;
	"orders.setpoint_temp_um": string;
	"orders.setpoint_var": number;
	"orders.setpoint_var_um": string;
	"orders.ship_status_to_edi": string;
	"orders.shipment_id": string;
	"orders.shipper_stop_id": string;
	"orders.shipstatus2edi_dt": Date;
	"orders.ss_location_id": string;
	"orders.status": string;
	"orders.subject_order_number": string;
	"orders.subject_order_status": string;
	"orders.subject_order_void_date": Date;
	"orders.swap": string;
	"orders.teams_required": string;
	"orders.temperature_max": number;
	"orders.temperature_max_um": string;
	"orders.temperature_min": number;
	"orders.temperature_min_um": string;
	"orders.total_charge": number;
	"orders.total_charge_c": string;
	"orders.total_charge_d": Date;
	"orders.total_charge_n": number;
	"orders.total_charge_r": number;
	"orders.totalcharge_and_excisetax": number;
	"orders.totalcharge_and_excisetax_c": string;
	"orders.totalcharge_and_excisetax_d": Date;
	"orders.totalcharge_and_excisetax_n": number;
	"orders.totalcharge_and_excisetax_r": number;
	"orders.tractor_type": string;
	"orders.vessel": string;
	"orders.vessel_cutoff_date": Date;
	"orders.voided_load_transmitted": string;
	"orders.voided_load_transmitted_dt": Date;
	"orders.weight": number;
	"orders.weight_um": string;
	"orders.xferred2billing": string;
	"orders.xferred2billing_dt": Date;
	orders_status: string;
	orders_xferred2billing: string;
	partner_id: string;
	partner_stop_no: string;
	prev_plant: string;
	prev_status_date: Date;
	prev_stop_id: string;
	pro_nbr: string;
	ready_to_send: string;
	refno: string;
	scac: string;
	sched_arrive_early: Date;
	sched_arrive_late: Date;
	seal: string;
	service_standard: number;
	ship_address: string;
	ship_address_inbound: string;
	ship_city_id: string;
	ship_city_id_inbound: string;
	ship_city_name: string;
	ship_city_name_inbound: string;
	ship_latitude_inbound: string;
	ship_loc_id: string;
	ship_loc_name: string;
	ship_loc_name_inbound: string;
	ship_longitude_inbound: string;
	ship_match_descr: string;
	ship_match_type: string;
	ship_state: string;
	ship_state_inbound: string;
	"ship_stop.actual_arrival": Date;
	"ship_stop.actual_departure": Date;
	"ship_stop.address": string;
	"ship_stop.address2": string;
	"ship_stop.appointment_status_id": string;
	"ship_stop.appt_contact_name": string;
	"ship_stop.appt_required": string;
	"ship_stop.cases": number;
	"ship_stop.city_id": number;
	"ship_stop.city_name": string;
	"ship_stop.company_id": string;
	"ship_stop.confirmed": string;
	"ship_stop.contact_email": string;
	"ship_stop.contact_name": string;
	"ship_stop.dist_from_prev": number;
	"ship_stop.dist_from_prev_um": string;
	"ship_stop.driver_load_unload": string;
	"ship_stop.edi_code": string;
	"ship_stop.edi_loc_code": string;
	"ship_stop.eta": Date;
	"ship_stop.eta_distance": number;
	"ship_stop.eta_late": string;
	"ship_stop.eta_oor": string;
	"ship_stop.google_place_id": string;
	"ship_stop.grouped_id": number;
	"ship_stop.hub": number;
	"ship_stop.ic_stop_id": string;
	"ship_stop.id": string;
	"ship_stop.inbound_status": string;
	"ship_stop.late_eta_colorcode": string;
	"ship_stop.late_route_status": string;
	"ship_stop.latitude": number;
	"ship_stop.location_id": string;
	"ship_stop.location_name": string;
	"ship_stop.longitude": number;
	"ship_stop.manifest_fgp_uid": number;
	"ship_stop.manifest_reg_uid": number;
	"ship_stop.move_dist_from_preassign": number;
	"ship_stop.move_dist_from_preassign_um": string;
	"ship_stop.move_dist_from_previous": number;
	"ship_stop.move_dist_from_previous_um": string;
	"ship_stop.movement_id": string;
	"ship_stop.movement_sequence": number;
	"ship_stop.operational_status": string;
	"ship_stop.order_id": string;
	"ship_stop.order_sequence": number;
	"ship_stop.orig_sched_early": Date;
	"ship_stop.orig_sched_late": Date;
	"ship_stop.pallets_dropped": number;
	"ship_stop.pallets_picked_up": number;
	"ship_stop.payment_code_reviewed": string;
	"ship_stop.phone": string;
	"ship_stop.planned_arrival_time": Date;
	"ship_stop.ponum": string;
	"ship_stop.prior_uncleared_stops": string;
	"ship_stop.projected_arrival": Date;
	"ship_stop.pu_override_arrive_early": Date;
	"ship_stop.pu_override_arrive_late": Date;
	"ship_stop.rate_dist_from_previous": number;
	"ship_stop.rate_dist_from_previous_um": string;
	"ship_stop.refno": string;
	"ship_stop.requested_service": string;
	"ship_stop.sched_arrive_early": Date;
	"ship_stop.sched_arrive_late": Date;
	"ship_stop.seal": string;
	"ship_stop.service_date": Date;
	"ship_stop.showas_address": string;
	"ship_stop.showas_address2": string;
	"ship_stop.showas_city_id": number;
	"ship_stop.showas_city_name": string;
	"ship_stop.showas_location_id": string;
	"ship_stop.showas_location_name": string;
	"ship_stop.showas_state": string;
	"ship_stop.showas_zip_code": string;
	"ship_stop.signed_for_name": string;
	"ship_stop.state": string;
	"ship_stop.status": string;
	"ship_stop.stop_type": string;
	"ship_stop.trimble_place_id": string;
	"ship_stop.txl_uid": number;
	"ship_stop.volume": number;
	"ship_stop.volume_um": string;
	"ship_stop.weight": number;
	"ship_stop.weight_um": string;
	"ship_stop.zip_code": string;
	"ship_stop.zone_id": string;
	ship_stop_id: string;
	ship_zip_code: string;
	ship_zip_code_inbound: string;
	shipment_id: string;
	"shipper_location.address1": string;
	"shipper_location.address2": string;
	"shipper_location.appt_required": string;
	"shipper_location.assigned_to": string;
	"shipper_location.bseg": string;
	"shipper_location.category": string;
	"shipper_location.cbsa_port_id": string;
	"shipper_location.chassis_owner": string;
	"shipper_location.chassis_pool": string;
	"shipper_location.city_id": number;
	"shipper_location.city_name": string;
	"shipper_location.class_rqmt": string;
	"shipper_location.comments": string;
	"shipper_location.company_id": string;
	"shipper_location.container_pool": string;
	"shipper_location.container_vendor": string;
	"shipper_location.cust_id": string;
	"shipper_location.customer_id": string;
	"shipper_location.days_between_calls": number;
	"shipper_location.ded_rqmt_type": string;
	"shipper_location.ded_type": string;
	"shipper_location.def_commodity_desc": string;
	"shipper_location.def_commodity_id": string;
	"shipper_location.delivery_date_option": string;
	"shipper_location.directions": string;
	"shipper_location.disable_loc_rating": string;
	"shipper_location.dl_gen_cost": number;
	"shipper_location.dl_gen_repower": number;
	"shipper_location.dl_haz_cost": number;
	"shipper_location.dl_haz_repower": number;
	"shipper_location.dl_hvl_cost": number;
	"shipper_location.dl_hvl_repower": number;
	"shipper_location.dl_load_time": number;
	"shipper_location.dl_svc_cost": number;
	"shipper_location.dl_svc_repower": number;
	"shipper_location.dl_unload_time": number;
	"shipper_location.driver_load_id": string;
	"shipper_location.driver_unload_id": string;
	"shipper_location.ds_capacity_cost": number;
	"shipper_location.ds_model_flag": string;
	"shipper_location.extra_handling_time": number;
	"shipper_location.filer_code": string;
	"shipper_location.foreign_port": string;
	"shipper_location.friday_close": Date;
	"shipper_location.friday_open": Date;
	"shipper_location.fuel_price_region": string;
	"shipper_location.google_place_fm_address": string;
	"shipper_location.google_place_id": string;
	"shipper_location.google_place_type": string;
	"shipper_location.id": string;
	"shipper_location.include_xref_trailers": string;
	"shipper_location.insur_amt_rqrd": number;
	"shipper_location.insur_amt_rqrd_c": string;
	"shipper_location.insur_amt_rqrd_d": Date;
	"shipper_location.insur_amt_rqrd_n": number;
	"shipper_location.insur_amt_rqrd_r": number;
	"shipper_location.is_active": string;
	"shipper_location.is_consignee": string;
	"shipper_location.is_customer": string;
	"shipper_location.is_customs_broker": string;
	"shipper_location.is_dist_center": string;
	"shipper_location.is_dl_gen": string;
	"shipper_location.is_dl_haz": string;
	"shipper_location.is_dl_hvl": string;
	"shipper_location.is_dl_svc": string;
	"shipper_location.is_drop_yard": string;
	"shipper_location.is_geocoded": string;
	"shipper_location.is_outside_terminal": string;
	"shipper_location.is_prospect": string;
	"shipper_location.is_remote_terminal": string;
	"shipper_location.is_shipper": string;
	"shipper_location.is_steamship": string;
	"shipper_location.is_terminal": string;
	"shipper_location.is_trailer_pool": string;
	"shipper_location.is_trailer_wash": string;
	"shipper_location.is_truckstop": string;
	"shipper_location.last_used_date": Date;
	"shipper_location.latitude": number;
	"shipper_location.layover": string;
	"shipper_location.load_unload_count": number;
	"shipper_location.load_unload_excl": string;
	"shipper_location.load_unload_param": string;
	"shipper_location.loading_instructs": string;
	"shipper_location.loading_time": number;
	"shipper_location.longitude": number;
	"shipper_location.ltl_optimize_time_per_spot": number;
	"shipper_location.ltl_seg_alloc_code": string;
	"shipper_location.manual_exchange": string;
	"shipper_location.max_drvr_complaint": number;
	"shipper_location.max_pallet_balance": number;
	"shipper_location.max_payment_code_amt": number;
	"shipper_location.max_payment_code_amt_c": string;
	"shipper_location.max_payment_code_amt_d": Date;
	"shipper_location.max_payment_code_amt_n": number;
	"shipper_location.max_payment_code_amt_r": number;
	"shipper_location.model_flag": string;
	"shipper_location.monday_close": Date;
	"shipper_location.monday_open": Date;
	"shipper_location.name": string;
	"shipper_location.need_clean_trailer": string;
	"shipper_location.next_call_date": Date;
	"shipper_location.no_fuel_radius_inbound": string;
	"shipper_location.no_fuel_radius_outbound": number;
	"shipper_location.no_stop_miles": number;
	"shipper_location.on_duty_not_driving_mins": number;
	"shipper_location.pallet_balance": number;
	"shipper_location.pallets_required": string;
	"shipper_location.payment_api_excluded": string;
	"shipper_location.pickup_date_option": string;
	"shipper_location.plc_uid": number;
	"shipper_location.pnn_city_id": number;
	"shipper_location.pnn_city_name": string;
	"shipper_location.pnn_state": string;
	"shipper_location.pnn_zip_code": string;
	"shipper_location.port_id": string;
	"shipper_location.prev_code": string;
	"shipper_location.primary_agency": string;
	"shipper_location.radius": number;
	"shipper_location.regulated": string;
	"shipper_location.reload_rqmt": string;
	"shipper_location.reserve_mins": number;
	"shipper_location.salesperson": string;
	"shipper_location.saturday_close": Date;
	"shipper_location.saturday_open": Date;
	"shipper_location.shuttle_capacity": string;
	"shipper_location.state": string;
	"shipper_location.sunday_close": Date;
	"shipper_location.sunday_open": Date;
	"shipper_location.swap_cost": number;
	"shipper_location.team_rqmt": string;
	"shipper_location.thursday_close": Date;
	"shipper_location.thursday_open": Date;
	"shipper_location.trailer_pool_min": number;
	"shipper_location.trailer_pool_radius": number;
	"shipper_location.trailer_pool_size": number;
	"shipper_location.trailer_wash_vend": string;
	"shipper_location.trimble_place_id": string;
	"shipper_location.trip_starter": string;
	"shipper_location.tuesday_close": Date;
	"shipper_location.tuesday_open": Date;
	"shipper_location.tw_seg_code": string;
	"shipper_location.unload_instructs": string;
	"shipper_location.unloading_time": number;
	"shipper_location.website_url": string;
	"shipper_location.wednesday_close": Date;
	"shipper_location.wednesday_open": Date;
	"shipper_location.zip_code": string;
	shipper_plant: string;
	source_record_id: string;
	source_record_type: string;
	st02_trxset_cntlno: string;
	standard_description: string;
	status_code: string;
	status_date: Date;
	status_description: string;
	status_type: string;
	stop_description: string;
	stop_number: string;
	stops_list: string;
	tid: number;
	timezone_id: string;
	tractor_id: string;
	trailer_id: string;
	trans_count: number;
	transmission_status: string;
	transmit_status: string;
	transmitted: string;
	trip_lease: string;
	update_date: Date;
	update_user_id: string;
	version: string;
	xmit_sequence: number;
	cons_loc_id_search: string;
	from_view_edi_status: boolean;
	has_error: string;
	has_transmitted: string;
	search_error: string;
	search_error_descr: string;
	search_reference_numbers: string;
	ship_loc_id_search: string;
	suppress_batch: boolean;
	validate_model: boolean;
}
